var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-2"},[_c('v-card',{staticClass:"mt-2 d-flex justify-center"},[_c('img',{attrs:{"src":require("../../assets/img/Frame_dashboard.jpg"),"alt":""}})]),_c('ViewSetDirectHeadDialog',{attrs:{"data":_vm.head_data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }